<template>
    <div class="flex flex-col gap-8">
        <h1 class="text-white text-3xl font-bold ">Token Supply Dashboard</h1>
        <LivewatchSummary v-if="overview" :overview="overview" />
        <LivewatchOverview v-if="overview" :overview="overview" />
        <LivewatchCirculatingBreakDown v-if="circulatingBreakDown" :circulatingBreakDown="circulatingBreakDown" />
        <LivewatchCirculatingSupplyTracker v-if="tracker" :tracker="tracker" />
        <LivewatchScheduleSupplyTracker v-if="!isScheduleSupplyTrackerLoading" :scheduleSupplyTracker="scheduleSupplyTracker" :scheduleSupplyDonut="scheduleSupplyDonut" v-model="selectedDate" />
        <LivewatchWalletBalanceTracker v-if="walletBalanceTracker" :walletBalanceTracker="walletBalanceTracker" />
    </div>
</template>

<script setup lang="ts">
import { getLivewatchOverview } from '~/api/service/livewatch/overview.service';
import { getLivewatchCirculatingSupplyTracker } from '~/api/service/livewatch/circulating-supply-tracker.service';
import { getLivewatchTotalSupplyBreakdown } from '~/api/service/livewatch/total-supply-breakdown.service';
import { getLivewatchScheduleSupplyTracker } from '~/api/service/livewatch/schedule-supply-tracker.service';
import { getLivewatchScheduleSupplyDonut } from '~/api/service/livewatch/schedule-supply-donut.service';
import { getLivewatchWalletBalanceTracker } from '~/api/service/livewatch/wallet-balance-tracker.service';
import LivewatchCirculatingSupplyTracker from '~/components/@pages/livewatch/LivewatchCirculatingSupplyTracker.vue';
import LivewatchCirculatingBreakDown from '~/components/@pages/livewatch/LivewatchCirculatingBreakDown.vue';
import LivewatchOverview from '~/components/@pages/livewatch/LivewatchOverview.vue';
import LivewatchScheduleSupplyTracker from '~/components/@pages/livewatch/LivewatchScheduleSupplyTracker.vue';
import LivewatchWalletBalanceTracker from '~/components/@pages/livewatch/LivewatchWalletBalanceTracker.vue';
import LivewatchSummary from '~/components/@pages/livewatch/LivewatchSummary.vue';

useSeoMeta({
  title: 'Token Supply Dashboard',
  description: 'View the NXPC supply breakdown on MapleStory Universe Explorer',
  ogDescription: 'View the NXPC supply breakdown on MapleStory Universe Explorer',
  twitterDescription: 'View the NXPC supply breakdown on MapleStory Universe Explorer',
});

const selectedDate = ref(new Date().setUTCHours(0, 0, 0, 0))

const { data: overview } = getLivewatchOverview()
const { data: circulatingBreakDown } = getLivewatchTotalSupplyBreakdown()
const { data: tracker } = getLivewatchCirculatingSupplyTracker()
const { data: scheduleSupplyTracker, isInitialLoading: isScheduleSupplyTrackerLoading } = getLivewatchScheduleSupplyTracker()
const { data: scheduleSupplyDonut } = getLivewatchScheduleSupplyDonut({ date: selectedDate })
const { data: walletBalanceTracker } = getLivewatchWalletBalanceTracker()
</script>
